import React from 'react';
import Reflux from 'reflux';
import {Button, Row, Col, Modal, Radio, Select, Input, message} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {objectSerial, config} from 'Utils';
import {getStoreOutInList} from '../../service/product';
import {getSubStoreList} from "../../service/thingsOrder";

class storeOutInList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['收发存报表'],
            key: 0,
            selectedRowKeys: [],
            selectedRows: [],
            subStoreList: [],
            rows: [],
            total: 1,
            searchObj: {
                code: '', // 物料编号
                name: '',//物料描述
                subStoreId: '', // 子库id
                orderStartDate: '', // 起
                orderEndDate: '', // 止
                s: 10,
                p: 1
            },
            visible: false,
            button_limits_end: {},
            loading: false
        };
        this.pageChange = this.pageChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    };

    /*路径跳转*/
    goView(url) {
        hashHistory.push(url);
    };


    /*筛选*/
    setFilterParam(name, value) {
        if (name === 'shipTime') {
            this.setState({
                searchObj: {
                    ...this.state.searchObj,
                    orderStartDate: value.from,
                    orderEndDate: value.end
                }
            })
        } else {
            this.setState({searchObj: {...this.state.searchObj, [name]: value}})
        }
    };

    /*筛选重置*/
    advanceReset() {
        const self = this;
        this.setState({
            searchObj: {
                ...this.state.searchObj,
                code: '', // 物料编号
                name: '',//物料描述
                subStoreId: '', // 子库id
                orderStartDate: '', // 起
                orderEndDate: '', // 止
                p: 0,
                s: 10,
            }, loading: true
        }, () => {
            self.initData();
        })
    };

    /* 筛选确认 */
    advanceSubmit(form) {
        const self = this;
        var sObj = this.state.searchObj;
        this.setState({searchObj: {...this.state.searchObj, p: 1}, loading: true}, function () {
            self.initData();
        });
    };

    /*翻页*/
    pageChange(page, pageSize) {
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    /*获取列表数据*/
    initData() {
        var obj = this.state.searchObj;
        if (obj.orderEndDate == '' || obj.orderStartDate == '') {
            openNotice('error', '请先选择日期范围');
            this.setState({loading: false});
            return;
        }
        getStoreOutInList(obj).then(result => {
            if (result.status) {
                this.setState({
                    rows: result.data || [],
                    total: result.total || 1,
                    loading: false
                })
            } else {
                this.setState({
                    loading: false
                })
                message.error(result.message);
            }
        })
    }

    onSelectChange = (selectedRowKeys, selectedRows) => {
        this.setState({selectedRowKeys, selectedRows});
        // console.log()
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
    }

    componentWillMount() {
    }

    exportChange = () => {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/dmsTianGoodsStore/storeOutInExport?${objectSerial(_searchObj)}`;
        window.open(url);
    }

    componentDidMount() {
        //this.initData();
        getSubStoreList({
            removeFlag: 0,
            s: 1000,
            p: 1,
        }).then((result) => { //获取子库存
            if (result && result.code == 200) {
                let arr = [];
                arr.push({value: '', text: '全部'});
                result.data.forEach(item => {
                    arr.push({value: item.id, text: item.subStoreName});
                })
                this.setState({subStoreList: arr});
            } else {
                openNotice('error', '获取数据失败', result.message || '');
            }
        });
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    render() {
        var self = this;
        const {opts, key, rows, total, selectedRowKeys, searchObj, visible, button_limits_end, loadingsubStoreList, loading, subStoreList} = this.state;
        const advanceProps = {
            fileds: [
                {
                    name: 'shipTime',//startCreatedDate, endCreatedDate
                    label: '日期范围',
                    options: [
                        {text: '开始时间'},
                        {text: '结束时间'},
                    ],
                    type: 'dateComp',
                    defaultValue: {
                        from: searchObj.orderStartDate || '',
                        end: searchObj.orderEndDate || ''
                    }
                },
                {
                    name: 'code',
                    label: '物料编码',
                    text: '输入物料编码',
                    type: 'default',
                    defaultValue: searchObj.code
                },
                {
                    name: 'name',
                    label: '物料描述',
                    text: '输入物料描述',
                    type: 'default',
                    defaultValue: searchObj.name
                },
                {
                    name: 'subStoreId',
                    label: '子库存',
                    text: '输入子库存',
                    type: 'select',
                    defaultValue: searchObj.subStoreId,
                    howSearch: true,
                    options: subStoreList,
                },
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'itemNum',
                }, {
                    title: '物料描述',
                    dataIndex: 'itemDesc',
                }, {
                    title: '子库编码',
                    dataIndex: 'subStoreNumber'
                }, {
                    title: '子库名称',
                    dataIndex: 'subStoreName'
                }, {
                    title: '期初数量',
                    dataIndex: 'startNum'
                }, {
                    title: '采购入库',
                    dataIndex: 'orderStore'
                },
                {
                    title: '采购退货',
                    dataIndex: 'returnStore'
                },
                {
                    title: '销售出库',
                    dataIndex: 'transOrderStore'
                },
                {
                    title: '退货入库',
                    dataIndex: 'transReturnStore'
                },
                {
                    title: '杂项事务',
                    dataIndex: 'sundryStore'
                },
                {
                    title: '子库转移',
                    dataIndex: 'transferStore'
                },
                {
                    title: '库存盘点',
                    dataIndex: 'inventoryStore'
                },
                {
                    title: '期末数量',
                    dataIndex: 'endNum'
                },
            ],
            rows,
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew {...advanceProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    <Button style={{position: 'absolute', bottom: 8, right: 0}} icon="export"
                            onClick={this.exportChange.bind(this)}>导出</Button>
                </div>
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}
;
export default withRouter(storeOutInList);


// WEBPACK FOOTER //
// ./src/routes/stockControl/storeOutInList.js